import { render, staticRenderFns } from "./eventToPro.vue?vue&type=template&id=fd5bf358&scoped=true&"
import script from "./eventToPro.vue?vue&type=script&lang=js&"
export * from "./eventToPro.vue?vue&type=script&lang=js&"
import style0 from "./eventToPro.vue?vue&type=style&index=0&id=fd5bf358&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5bf358",
  null
  
)

export default component.exports